/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime.js';
import { CfarContractFromJSON, CfarContractCustomerFromJSON, CfarContractExerciseFromJSON, CfarExerciseCustomerResponseFromJSON, CfarExercisePayoutCurrencyConversionResponseFromJSON, CfarOfferFromJSON, CfarOfferCustomerFromJSON, CfarPaymentFromJSON, CheckCfarContractExerciceVerificationCodeResponseFromJSON, CheckCfarContractExerciseVerificationCodeRequestToJSON, CreateCfarContractCustomerRequestToJSON, CreateCfarContractExerciseCustomerRequestToJSON, CreateCfarContractExerciseCustomerResponseFromJSON, CreateCfarContractExerciseRequestToJSON, CreateCfarContractRequestToJSON, CreateCfarExerciseRequestToJSON, CreateCfarExerciseResponseFromJSON, CreateCfarOfferCustomerRequestToJSON, CreateCfarOfferRequestToJSON, CreateRefundRecipientRequestToJSON, GetCfarExerciseCustomerLightResponseFromJSON, GetCfarOfferResponseFromJSON, GetSessionCustomerResponseFromJSON, InitiatePayoutRequestToJSON, InitiatePayoutResponseFromJSON, InitiateRefundRequestToJSON, InitiateRefundResponseFromJSON, MarkCfarContractExerciseCompleteRequestToJSON, ProcessCfarPaymentRequestToJSON, RefundAuthorizationFromJSON, RefundRecipientFromJSON, SendCfarContractExerciceVerificationCodeResponseFromJSON, UpdateCfarContractRequestToJSON, UpdateCfarFormOfPaymentRequestToJSON, } from '../models/index.js';
/**
 *
 */
export class CancelForAnyReasonCFARApi extends runtime.BaseAPI {
    /**
     * Get a CFAR contract
     * Get a CFAR Contract
     */
    getCfarContractsIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCfarContractsId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contracts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
        });
    }
    /**
     * Get a CFAR contract
     * Get a CFAR Contract
     */
    getCfarContractsId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCfarContractsIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new event for analytics using a tracking pixel
     * Create an event using a tracking pixel
     */
    getCustomerAnalyticsHcsessionidEventnameRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.hcSessionId === null || requestParameters.hcSessionId === undefined) {
                throw new runtime.RequiredError('hcSessionId', 'Required parameter requestParameters.hcSessionId was null or undefined when calling getCustomerAnalyticsHcsessionidEventname.');
            }
            if (requestParameters.eventName === null || requestParameters.eventName === undefined) {
                throw new runtime.RequiredError('eventName', 'Required parameter requestParameters.eventName was null or undefined when calling getCustomerAnalyticsHcsessionidEventname.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/customer/analytics/{hcSessionId}/{eventName}`.replace(`{${"hcSessionId"}}`, encodeURIComponent(String(requestParameters.hcSessionId))).replace(`{${"eventName"}}`, encodeURIComponent(String(requestParameters.eventName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Create a new event for analytics using a tracking pixel
     * Create an event using a tracking pixel
     */
    getCustomerAnalyticsHcsessionidEventname(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerAnalyticsHcsessionidEventnameRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a CFAR contract
     * Get a CFAR Exercise
     */
    getCustomerCfarContractExercisesIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCustomerCfarContractExercisesId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/cfar_contract_exercises/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCfarExerciseCustomerLightResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get a CFAR contract
     * Get a CFAR Exercise
     */
    getCustomerCfarContractExercisesId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerCfarContractExercisesIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a CFAR contract
     * Get a CFAR Exercise
     */
    getCustomerCfarExercisesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/cfar_exercises`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarExerciseCustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get a CFAR contract
     * Get a CFAR Exercise
     */
    getCustomerCfarExercises() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getCustomerCfarExercisesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the currency conversion for the specified exercise\'s payout
     * Get currency conversion for an exercise\'s payout
     */
    getCustomerCfarExercisesIdPayoutCurrencyConversionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCustomerCfarExercisesIdPayoutCurrencyConversion.');
            }
            if (requestParameters.targetCurrency === null || requestParameters.targetCurrency === undefined) {
                throw new runtime.RequiredError('targetCurrency', 'Required parameter requestParameters.targetCurrency was null or undefined when calling getCustomerCfarExercisesIdPayoutCurrencyConversion.');
            }
            const queryParameters = {};
            if (requestParameters.targetCurrency !== undefined) {
                queryParameters['target_currency'] = requestParameters.targetCurrency;
            }
            const headerParameters = {};
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/cfar_exercises/{id}/payout_currency_conversion`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarExercisePayoutCurrencyConversionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get the currency conversion for the specified exercise\'s payout
     * Get currency conversion for an exercise\'s payout
     */
    getCustomerCfarExercisesIdPayoutCurrencyConversion(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerCfarExercisesIdPayoutCurrencyConversionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get CFAR offers
     * Get CFAR Offers
     */
    getCustomerCfarOffersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === undefined) {
                throw new runtime.RequiredError('hCSessionID', 'Required parameter requestParameters.hCSessionID was null or undefined when calling getCustomerCfarOffers.');
            }
            const queryParameters = {};
            if (requestParameters.offerId) {
                queryParameters['offerId'] = requestParameters.offerId;
            }
            const headerParameters = {};
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            const response = yield this.request({
                path: `/customer/cfar_offers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCfarOfferResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get CFAR offers
     * Get CFAR Offers
     */
    getCustomerCfarOffers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerCfarOffersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieve main data of a customer session
     * Get data for a customer session
     */
    getCustomerSessionsRetrieveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/sessions/retrieve`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSessionCustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieve main data of a customer session
     * Get data for a customer session
     */
    getCustomerSessionsRetrieve(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerSessionsRetrieveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has occurred.
     * Create CFAR Exercise
     */
    postCfarContractExercisesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarContractExerciseRequest === null || requestParameters.createCfarContractExerciseRequest === undefined) {
                throw new runtime.RequiredError('createCfarContractExerciseRequest', 'Required parameter requestParameters.createCfarContractExerciseRequest was null or undefined when calling postCfarContractExercises.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contract_exercises`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarContractExerciseRequestToJSON(requestParameters.createCfarContractExerciseRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractExerciseFromJSON(jsonValue));
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has occurred.
     * Create CFAR Exercise
     */
    postCfarContractExercises(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCfarContractExercisesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a CFAR contract from selected CFAR offer(s).
     * Create a CFAR Contract
     */
    postCfarContractsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarContractRequest === null || requestParameters.createCfarContractRequest === undefined) {
                throw new runtime.RequiredError('createCfarContractRequest', 'Required parameter requestParameters.createCfarContractRequest was null or undefined when calling postCfarContracts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contracts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarContractRequestToJSON(requestParameters.createCfarContractRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
        });
    }
    /**
     * Create a CFAR contract from selected CFAR offer(s).
     * Create a CFAR Contract
     */
    postCfarContracts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCfarContractsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * When HTS is the Merchant of Record (MoR), the customer\'s credit card is charged by HTS for the CFAR fee.  HTS is relying on an external payment gateway to process the payments, it allows the partner airline to tokenize the customer\'s credit card details and then pass the generated token in HTS Ancillaries for Airlines API payment endpoints in order to process the payment and confirm the contract related to the purchased product.  **Token URL**: https://core.spreedly.com/v1/payment_methods.json    **Example Token Request**:      ```   curl --request POST --url https://core.spreedly.com/v1/payment_methods.json --header \'content-type: application/json\' -u  \"login:password\" --data \'{  \"payment_method\": {   \"email\": \"aaa@bbb.ccc\",   \"credit_card\": {    \"number\": \"4111111111111111\",    \"month\": \"09\",    \"year\": \"2029\",    \"first_name\": \"John\",    \"last_name\": \"Smith\",    \"address1\": \"123 12th St\",    \"address2\": \"Building B\",    \"city\": \"Quebec City\",    \"state\": \"QC\",    \"zip\": \"G1R 4S9\",    \"country\": \"CA\",    \"verification_value\": \"123\"   }  } }\' ``` **Example Token Response**:   ```   {  \"transaction\":  {   \"token\":  \"KtToV20m9qT1Yi8pbTeLNz0Ypns\",   \"created_at\":  \"2023-11-29T13:31:56Z\",   \"updated_at\":  \"2023-11-29T13:31:56Z\",   \"succeeded\":  true,   \"transaction_type\":  \"AddPaymentMethod\",   \"retained\":  false,   \"state\":  \"succeeded\",   \"message_key\":  \"messages.transaction_succeeded\",   \"message\":  \"Succeeded!\",   \"payment_method\":  {    \"token\":  \"MxyYEhDK12CUAA18bJDkAq0ab3y\",    \"created_at\":  \"2023-11-29T13:31:56Z\",    \"updated_at\":  \"2023-11-29T13:31:56Z\",    \"email\":  \"aaa@bbb.ccc\",    \"data\":  null,    \"storage_state\":  \"cached\",    \"test\":  true,    \"metadata\":  null,    \"callback_url\":  null,    \"last_four_digits\":  \"1111\",    \"first_six_digits\":  \"411111\",    \"card_type\":  \"visa\",    \"first_name\":  \"John\",    \"last_name\":  \"Smith\",    \"month\":  9,    \"year\":  2029,    \"address1\":  \"123 12th St\",    \"address2\":  \"Building B\",    \"city\":  \"Quebec City\",    \"state\":  \"QC\",    \"zip\":  \"G1R 4S9\",    \"country\":  \"CA\",    \"phone_number\":  null,    \"company\":  null,    \"full_name\":  \"John Smith\",    \"eligible_for_card_updater\":  true,    \"shipping_address1\":  null,    \"shipping_address2\":  null,    \"shipping_city\":  null,    \"shipping_state\":  null,    \"shipping_zip\":  null,    \"shipping_country\":  null,    \"shipping_phone_number\":  null,    \"issuer_identification_number\":  \"41111111\",    \"click_to_pay\":  false,    \"managed\":  true,    \"payment_method_type\":  \"credit_card\",    \"errors\":  [],    \"bin_metadata\":  {     \"message\":  \"BIN Metadata is available only to Advanced Vault enrolled customers and payment methods. Reach out to your account representative for more details.\"    },    \"fingerprint\":  \"7ccffcf38900f224fc946cf2a9c8e260072b\",    \"verification_value\":  \"XXX\",    \"number\":  \"XXXX-XXXX-XXXX-1111\"   }  } } ``` Here the returned payment method token **MxyYEhDK12CUAA18bJDkAq0ab3y** has to be used in the Process CFAR Payment request below.
     * Process CFAR Payment
     */
    postCfarContractsIdPaymentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling postCfarContractsIdPayment.');
            }
            if (requestParameters.processCfarPaymentRequest === null || requestParameters.processCfarPaymentRequest === undefined) {
                throw new runtime.RequiredError('processCfarPaymentRequest', 'Required parameter requestParameters.processCfarPaymentRequest was null or undefined when calling postCfarContractsIdPayment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contracts/{id}/payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProcessCfarPaymentRequestToJSON(requestParameters.processCfarPaymentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarPaymentFromJSON(jsonValue));
        });
    }
    /**
     * When HTS is the Merchant of Record (MoR), the customer\'s credit card is charged by HTS for the CFAR fee.  HTS is relying on an external payment gateway to process the payments, it allows the partner airline to tokenize the customer\'s credit card details and then pass the generated token in HTS Ancillaries for Airlines API payment endpoints in order to process the payment and confirm the contract related to the purchased product.  **Token URL**: https://core.spreedly.com/v1/payment_methods.json    **Example Token Request**:      ```   curl --request POST --url https://core.spreedly.com/v1/payment_methods.json --header \'content-type: application/json\' -u  \"login:password\" --data \'{  \"payment_method\": {   \"email\": \"aaa@bbb.ccc\",   \"credit_card\": {    \"number\": \"4111111111111111\",    \"month\": \"09\",    \"year\": \"2029\",    \"first_name\": \"John\",    \"last_name\": \"Smith\",    \"address1\": \"123 12th St\",    \"address2\": \"Building B\",    \"city\": \"Quebec City\",    \"state\": \"QC\",    \"zip\": \"G1R 4S9\",    \"country\": \"CA\",    \"verification_value\": \"123\"   }  } }\' ``` **Example Token Response**:   ```   {  \"transaction\":  {   \"token\":  \"KtToV20m9qT1Yi8pbTeLNz0Ypns\",   \"created_at\":  \"2023-11-29T13:31:56Z\",   \"updated_at\":  \"2023-11-29T13:31:56Z\",   \"succeeded\":  true,   \"transaction_type\":  \"AddPaymentMethod\",   \"retained\":  false,   \"state\":  \"succeeded\",   \"message_key\":  \"messages.transaction_succeeded\",   \"message\":  \"Succeeded!\",   \"payment_method\":  {    \"token\":  \"MxyYEhDK12CUAA18bJDkAq0ab3y\",    \"created_at\":  \"2023-11-29T13:31:56Z\",    \"updated_at\":  \"2023-11-29T13:31:56Z\",    \"email\":  \"aaa@bbb.ccc\",    \"data\":  null,    \"storage_state\":  \"cached\",    \"test\":  true,    \"metadata\":  null,    \"callback_url\":  null,    \"last_four_digits\":  \"1111\",    \"first_six_digits\":  \"411111\",    \"card_type\":  \"visa\",    \"first_name\":  \"John\",    \"last_name\":  \"Smith\",    \"month\":  9,    \"year\":  2029,    \"address1\":  \"123 12th St\",    \"address2\":  \"Building B\",    \"city\":  \"Quebec City\",    \"state\":  \"QC\",    \"zip\":  \"G1R 4S9\",    \"country\":  \"CA\",    \"phone_number\":  null,    \"company\":  null,    \"full_name\":  \"John Smith\",    \"eligible_for_card_updater\":  true,    \"shipping_address1\":  null,    \"shipping_address2\":  null,    \"shipping_city\":  null,    \"shipping_state\":  null,    \"shipping_zip\":  null,    \"shipping_country\":  null,    \"shipping_phone_number\":  null,    \"issuer_identification_number\":  \"41111111\",    \"click_to_pay\":  false,    \"managed\":  true,    \"payment_method_type\":  \"credit_card\",    \"errors\":  [],    \"bin_metadata\":  {     \"message\":  \"BIN Metadata is available only to Advanced Vault enrolled customers and payment methods. Reach out to your account representative for more details.\"    },    \"fingerprint\":  \"7ccffcf38900f224fc946cf2a9c8e260072b\",    \"verification_value\":  \"XXX\",    \"number\":  \"XXXX-XXXX-XXXX-1111\"   }  } } ``` Here the returned payment method token **MxyYEhDK12CUAA18bJDkAq0ab3y** has to be used in the Process CFAR Payment request below.
     * Process CFAR Payment
     */
    postCfarContractsIdPayment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCfarContractsIdPaymentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create CFAR offers for a user\'s trip
     * Create CFAR Offers
     */
    postCfarOffersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarOfferRequest === null || requestParameters.createCfarOfferRequest === undefined) {
                throw new runtime.RequiredError('createCfarOfferRequest', 'Required parameter requestParameters.createCfarOfferRequest was null or undefined when calling postCfarOffers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_offers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarOfferRequestToJSON(requestParameters.createCfarOfferRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CfarOfferFromJSON));
        });
    }
    /**
     * Create CFAR offers for a user\'s trip
     * Create CFAR Offers
     */
    postCfarOffers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCfarOffersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a CFAR exercise associated with a given contract
     * Create a CFAR exercise
     */
    postCustomerCfarContractExercisesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarContractExerciseCustomerRequest === null || requestParameters.createCfarContractExerciseCustomerRequest === undefined) {
                throw new runtime.RequiredError('createCfarContractExerciseCustomerRequest', 'Required parameter requestParameters.createCfarContractExerciseCustomerRequest was null or undefined when calling postCustomerCfarContractExercises.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCPartnerID !== undefined && requestParameters.hCPartnerID !== null) {
                headerParameters['HC-Partner-ID'] = String(requestParameters.hCPartnerID);
            }
            const response = yield this.request({
                path: `/customer/cfar_contract_exercises`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarContractExerciseCustomerRequestToJSON(requestParameters.createCfarContractExerciseCustomerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateCfarContractExerciseCustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a CFAR exercise associated with a given contract
     * Create a CFAR exercise
     */
    postCustomerCfarContractExercises(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerCfarContractExercisesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a CFAR contract from purchased CFAR offers
     * Create a CFAR Contract
     */
    postCustomerCfarContractsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarContractCustomerRequest === null || requestParameters.createCfarContractCustomerRequest === undefined) {
                throw new runtime.RequiredError('createCfarContractCustomerRequest', 'Required parameter requestParameters.createCfarContractCustomerRequest was null or undefined when calling postCustomerCfarContracts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.language !== undefined && requestParameters.language !== null) {
                headerParameters['language'] = String(requestParameters.language);
            }
            const response = yield this.request({
                path: `/customer/cfar_contracts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarContractCustomerRequestToJSON(requestParameters.createCfarContractCustomerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractCustomerFromJSON(jsonValue));
        });
    }
    /**
     * Create a CFAR contract from purchased CFAR offers
     * Create a CFAR Contract
     */
    postCustomerCfarContracts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerCfarContractsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a CFAR Exercise
     * Create a CFAR exercise
     */
    postCustomerCfarExercisesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarExerciseRequest === null || requestParameters.createCfarExerciseRequest === undefined) {
                throw new runtime.RequiredError('createCfarExerciseRequest', 'Required parameter requestParameters.createCfarExerciseRequest was null or undefined when calling postCustomerCfarExercises.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/customer/cfar_exercises`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarExerciseRequestToJSON(requestParameters.createCfarExerciseRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateCfarExerciseResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a CFAR Exercise
     * Create a CFAR exercise
     */
    postCustomerCfarExercises(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerCfarExercisesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a CFAR offers for a customer\'s trip
     * Create CFAR Offers
     */
    postCustomerCfarOffersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createCfarOfferCustomerRequest === null || requestParameters.createCfarOfferCustomerRequest === undefined) {
                throw new runtime.RequiredError('createCfarOfferCustomerRequest', 'Required parameter requestParameters.createCfarOfferCustomerRequest was null or undefined when calling postCustomerCfarOffers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.language !== undefined && requestParameters.language !== null) {
                headerParameters['language'] = String(requestParameters.language);
            }
            if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
                headerParameters['User-Agent'] = String(requestParameters.userAgent);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/cfar_offers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCfarOfferCustomerRequestToJSON(requestParameters.createCfarOfferCustomerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CfarOfferCustomerFromJSON));
        });
    }
    /**
     * Create a CFAR offers for a customer\'s trip
     * Create CFAR Offers
     */
    postCustomerCfarOffers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerCfarOffersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Check a verification code to a user required to process a CFAR exercise
     * Check a verification code associated with a CFAR exercise
     */
    postCustomerIdCheckExerciseVerificationCodeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling postCustomerIdCheckExerciseVerificationCode.');
            }
            if (requestParameters.checkCfarContractExerciseVerificationCodeRequest === null || requestParameters.checkCfarContractExerciseVerificationCodeRequest === undefined) {
                throw new runtime.RequiredError('checkCfarContractExerciseVerificationCodeRequest', 'Required parameter requestParameters.checkCfarContractExerciseVerificationCodeRequest was null or undefined when calling postCustomerIdCheckExerciseVerificationCode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/{id}/check_exercise_verification_code`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CheckCfarContractExerciseVerificationCodeRequestToJSON(requestParameters.checkCfarContractExerciseVerificationCodeRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CheckCfarContractExerciceVerificationCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     * Check a verification code to a user required to process a CFAR exercise
     * Check a verification code associated with a CFAR exercise
     */
    postCustomerIdCheckExerciseVerificationCode(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerIdCheckExerciseVerificationCodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Send a verification code to a user required to process a CFAR exercise
     * Send a verification code associated with a CFAR exercise
     */
    postCustomerIdSendExerciseVerificationCodeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling postCustomerIdSendExerciseVerificationCode.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling postCustomerIdSendExerciseVerificationCode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/{id}/send_exercise_verification_code`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SendCfarContractExerciceVerificationCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     * Send a verification code to a user required to process a CFAR exercise
     * Send a verification code associated with a CFAR exercise
     */
    postCustomerIdSendExerciseVerificationCode(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerIdSendExerciseVerificationCodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Initiate the payout
     * Create a payout
     */
    postCustomerInitiatePayoutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.initiatePayoutRequest === null || requestParameters.initiatePayoutRequest === undefined) {
                throw new runtime.RequiredError('initiatePayoutRequest', 'Required parameter requestParameters.initiatePayoutRequest was null or undefined when calling postCustomerInitiatePayout.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (requestParameters.xForwardedFor !== undefined && requestParameters.xForwardedFor !== null) {
                headerParameters['X-Forwarded-For'] = String(requestParameters.xForwardedFor);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/initiate_payout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InitiatePayoutRequestToJSON(requestParameters.initiatePayoutRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePayoutResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initiate the payout
     * Create a payout
     */
    postCustomerInitiatePayout(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerInitiatePayoutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Initiate the Refund
     * Create a Refund
     */
    postCustomerInitiateRefundRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.initiateRefundRequest === null || requestParameters.initiateRefundRequest === undefined) {
                throw new runtime.RequiredError('initiateRefundRequest', 'Required parameter requestParameters.initiateRefundRequest was null or undefined when calling postCustomerInitiateRefund.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (requestParameters.xForwardedFor !== undefined && requestParameters.xForwardedFor !== null) {
                headerParameters['X-Forwarded-For'] = String(requestParameters.xForwardedFor);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/initiate_refund`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InitiateRefundRequestToJSON(requestParameters.initiateRefundRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InitiateRefundResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initiate the Refund
     * Create a Refund
     */
    postCustomerInitiateRefund(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerInitiateRefundRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a Refund Authorization Token
     * Create a Refund Authorization Token
     */
    postCustomerRefundAuthorizationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/refund_authorizations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RefundAuthorizationFromJSON(jsonValue));
        });
    }
    /**
     * Create a Refund Authorization Token
     * Create a Refund Authorization Token
     */
    postCustomerRefundAuthorizations() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.postCustomerRefundAuthorizationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a Refund Recipient
     * Create a Refund Recipient
     */
    postCustomerRefundRecipientsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createRefundRecipientRequest === null || requestParameters.createRefundRecipientRequest === undefined) {
                throw new runtime.RequiredError('createRefundRecipientRequest', 'Required parameter requestParameters.createRefundRecipientRequest was null or undefined when calling postCustomerRefundRecipients.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/refund_recipients`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateRefundRecipientRequestToJSON(requestParameters.createRefundRecipientRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RefundRecipientFromJSON(jsonValue));
        });
    }
    /**
     * Create a Refund Recipient
     * Create a Refund Recipient
     */
    postCustomerRefundRecipients(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerRefundRecipientsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has been completed
     * Complete CFAR Exercise
     */
    putCfarContractExercisesIdMarkCompletedRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling putCfarContractExercisesIdMarkCompleted.');
            }
            if (requestParameters.markCfarContractExerciseCompleteRequest === null || requestParameters.markCfarContractExerciseCompleteRequest === undefined) {
                throw new runtime.RequiredError('markCfarContractExerciseCompleteRequest', 'Required parameter requestParameters.markCfarContractExerciseCompleteRequest was null or undefined when calling putCfarContractExercisesIdMarkCompleted.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contract_exercises/{id}/mark_completed`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: MarkCfarContractExerciseCompleteRequestToJSON(requestParameters.markCfarContractExerciseCompleteRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractExerciseFromJSON(jsonValue));
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has been completed
     * Complete CFAR Exercise
     */
    putCfarContractExercisesIdMarkCompleted(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putCfarContractExercisesIdMarkCompletedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update forms of payment linked with a CFAR contract
     * Update forms of payment of a CFAR Contract
     */
    putCfarContractsIdFormsOfPaymentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling putCfarContractsIdFormsOfPayment.');
            }
            if (requestParameters.updateCfarFormOfPaymentRequest === null || requestParameters.updateCfarFormOfPaymentRequest === undefined) {
                throw new runtime.RequiredError('updateCfarFormOfPaymentRequest', 'Required parameter requestParameters.updateCfarFormOfPaymentRequest was null or undefined when calling putCfarContractsIdFormsOfPayment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contracts/{id}/forms_of_payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCfarFormOfPaymentRequestToJSON(requestParameters.updateCfarFormOfPaymentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
        });
    }
    /**
     * Update forms of payment linked with a CFAR contract
     * Update forms of payment of a CFAR Contract
     */
    putCfarContractsIdFormsOfPayment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putCfarContractsIdFormsOfPaymentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update the CFAR contract
     * Update CFAR Contract Status
     */
    putCfarContractsIdUpdateStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling putCfarContractsIdUpdateStatus.');
            }
            if (requestParameters.updateCfarContractRequest === null || requestParameters.updateCfarContractRequest === undefined) {
                throw new runtime.RequiredError('updateCfarContractRequest', 'Required parameter requestParameters.updateCfarContractRequest was null or undefined when calling putCfarContractsIdUpdateStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cfar_contracts/{id}/update_status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCfarContractRequestToJSON(requestParameters.updateCfarContractRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CfarContractFromJSON(jsonValue));
        });
    }
    /**
     * Update the CFAR contract
     * Update CFAR Contract Status
     */
    putCfarContractsIdUpdateStatus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putCfarContractsIdUpdateStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
